module.exports = __webpack_public_path__ + "img/popup_title_bangzhu_cd21ebf9d.png";